import { LegalDocument } from '@/legal/components/LegalDocument';
import content from '@/legal/content/privacy-ru-v1.0.md?raw';

export function PrivacyPolicyPage() {
  return (
    <LegalDocument
      title="Политика конфиденциальности"
      content={content}
      version="1.0"
      effectiveDate="2026-05-07"
      readingMinutes={18}
      jurisdictions={['ru', 'eu', 'us']}
    />
  );
}
